import { render, staticRenderFns } from "./MentionsDropdown.vue?vue&type=template&id=134294b2"
import script from "./MentionsDropdown.vue?vue&type=script&lang=js"
export * from "./MentionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./MentionsDropdown.vue?vue&type=style&index=0&id=134294b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports